import {Observable} from "rxjs";
import {finalize, map} from "rxjs/operators";
import {AppModule} from "../app.module";
import {AlertService} from "../_services";

export function Load(): MethodDecorator {
  return function (target: Function, key: string, descriptor: any) {

    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const alertService = AppModule.injector.get(AlertService);
      alertService.loading.next(true)
      const result = originalMethod.apply(this, args);
      return (<Observable<any>>result).pipe(map(v => {  return v; }), finalize(() => alertService.loading.next(false)  ));
    }

    return descriptor;
  }
}
